import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '@angular/cdk/layout';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {TokenHttpInterceptor} from './security/token-http-interceptor';
import {UserFeedbackService} from './services/user-feedback.service';
import {MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDialogComponent} from './shared/components/mat-dialog/mat-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {ErrorInterceptor} from './security/error-http-interceptor';
import {LoginCallbackComponent} from './security/login-callback/login-callback.component';
import {LogoutCallbackComponent} from './security/logout-callback/logout-callback.component';
import {LoaderComponent} from './shared/components/loader/loader.component'
import {AuthModule} from 'angular-auth-oidc-client';
import {authConfig} from './auth-config';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {LoadingInterceptor} from "./utility/interceptors/loading.interceptor";
import {UtilityModule} from "./utility/utility.module";

@NgModule({
  declarations: [
    AppComponent,
    MatDialogComponent,
    LoginCallbackComponent,
    LogoutCallbackComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    MatFormFieldModule,
    AppRoutingModule,
    MatInputModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    AuthModule.forRoot({config: authConfig}),
    HttpClientModule,
    MatSnackBarModule,
    FlexLayoutModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    UtilityModule
  ],
  providers: [
    UserFeedbackService,
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 5000}},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    }
  ],

  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
